import React, { useEffect, useState } from 'react'
import { dispatchHandler } from '../../../helper/apiHelperFunctions';
import { useDispatch, useSelector } from 'react-redux';
import { getPermissionKey } from '../../../helper/permissions';
import { formatNumber, parseJwt } from '../../../helper/genericFunction';
import ProfilePlaceholder from '../../../assets/icons/ProfilePlaceholder.svg';
import { ScrollText, ThumbsUp } from 'lucide-react';
import Icons from '../../../assets/icons';
import GenericFormComponent from '../../../genericComponents/forms/GenericFormComponent';
import GenericCustomButton from '../../../genericComponents/GenericCustomButton';
import LanguageTranslator from '../../../locals/LanguageTranslator';

function UserDashboard(props) {

    const dispatch = useDispatch();
    const digiProcStore = useSelector(state => state.digiProcStore);
    const { getPiSummaryData } = digiProcStore;
    let tokenData = parseJwt(sessionStorage.getItem('token'));

    const [inputData, setInputData] = useState({});
    const [errorData, setErrorData] = useState({});

    const [userDashboardData, setUserDashboardData] = useState({})

    useEffect(() => {
        console.log("thisdsondsfndsf", inputData)
        let filters = {
            creationTime: {
                from: inputData?.dateRange?.[0]?.format('YYYY-MM-DD') || '',
                to: inputData?.dateRange?.[1]?.format('YYYY-MM-DD') || '',
            },
            siteCode: Object.keys(inputData?.name1 || {})?.join(',') || '',
            slCode: Object.keys(inputData?.slname || {})?.join(',') || '',
        }
        Object.keys(filters).forEach(key => {
            if (key == "creationTime" && !filters?.[key]?.from && !filters?.[key]?.to) {
                delete filters?.[key];

            }
            else if (!filters?.[key]) {
                delete filters?.[key];
            }
        });
        let payload = {
            displayName: "USER_WISE_PI_PO_DATA",
            filter: { ...filters },
            selfData: "true"
        }
        dispatchHandler(dispatch, "getPiSummaryRequest", payload, getPermissionKey("dashboard", "mydashboard", "view"));
    }, [inputData])

    useEffect(() => {
        if (getPiSummaryData?.isSuccess) {
            setUserDashboardData(getPiSummaryData?.data || {});
        }
    }, [getPiSummaryData?.isSuccess]);

    const FILTERS = [
        {
            value: "Site",
            key: "name1",
            code: "code",
            entity: "site",
            headerKeys: {
                multiSelectCol: {},
                'name1': { value: 'Site' },
                'code': { value: 'Code' }
            },
            itemKeys: {
                'name1': ['name1'],
                'code': ['code']
            },
            multiselect: {
                selectId: 'code',
            }
        },
        {
            value: "Vendor",
            key: "slname",
            code: "slcode",
            entity: "vendor",
            headerKeys: {
                multiSelectCol: {},
                'slname': { value: 'Vendor' },
                'slcode': { value: 'Code' }
            },
            itemKeys: {
                'slname': ['slname'],
                'slcode': ['slcode']
            },
            multiselect: {
                selectId: 'slcode',
            }
        }
    ];

    const provideInputs = () => {
        let inputFieldsData = [{ key: "dateRange", type: "range", placeholder: ['Start Date', 'End Date'] }]
        inputFieldsData.push(...FILTERS.map((config) => {
            return {
                key: config?.key,
                iconRight: <Icons.DownArrowFilled />,
                modalMainClass: "use-as-generic-dropdown",
                placeholder: `${config?.value}`,
                type: 'dropdown',
                value: inputData?.[config?.key],
                inputProps: () => ({
                    search: {
                        placeholder: `Search ${config?.value}`,
                    },
                    viewDataType: "table-view",
                    api: {
                        reduxState: 'generalStore',
                        apiName: 'getSearchFilters',
                        apiPayload: (params) => {
                            return {
                                "entity": config?.entity,
                                "key": config.key,
                                "code": config?.code,
                                "search": params?.currentSearch || "",
                                "searchBy": params.searchFilter || "CONTAINS",
                                "pageNo": params?.currentPage || 1,
                                "moduleName": "",
                                "other_data": {},
                                "columnName": {}
                            }
                        },
                        getMaxPage: (states, functions, response) => Number(response?.resource?.maxPage || ""),
                    },
                    getListData: (response) => {
                        switch (config.key) {
                            default: return response?.resource?.searchResultNew?.map(data => ({ [config.key]: data[config.key], ...data }))
                        }
                    },
                    headerKeys: config.headerKeys ?? {
                        multiSelectCol: { value: "" },
                        [config.key]: { value: [config.value] },
                    },
                    itemKeys: config.itemKeys ?? {
                        [config.key]: [config.key],
                    },
                    multiselect: {
                        selectId: config?.multiselect?.selectId,
                    }
                }),
            }
        }))
        return inputFieldsData
    }

    const renderLoadingSkeleton = () => {
        return <div className='w-full grid grid-cols-2 gap-5'>
            {
                Array.from({ length: 2 }).map(index => (
                    <div className='p-[1.5rem] !w-full flex flex-col bg-white'>
                        <div className='flex items-center justify-between gap-4'>
                            <div>
                                <div className='generic-skeleton w-[100px] !h-[15px]'></div>
                                <div className='generic-skeleton w-[75px] !h-[30px]'></div>
                            </div>
                            <div>
                                <div className='generic-skeleton w-[75px] !h-[15px]'></div>
                                <div className='generic-skeleton w-[100px] !h-[30px]'></div>
                            </div>
                            <div>
                                <div className='generic-skeleton w-[75px] !h-[15px]'></div>
                                <div className='generic-skeleton w-[100px] !h-[30px]'></div>
                            </div>

                        </div>
                        <div className='generic-skeleton w-full mt-[3rem] !mb-0'></div>
                        <div className='generic-skeleton w-[130px] !mt-[8px] !mb-0'></div>
                    </div>
                ))
            }
        </div>
    }

    // Function to render the primary filters data
    const renderPrimaryFilters = () => {
        return (
            <div className='proc-dashboard all-filter-dashboard procV2Styling p-lr-0 user-dashboard-filters'>
                <GenericFormComponent
                    rowInput={{
                        rowType: "singleRow",
                        availableInputs: provideInputs(),
                        inputState: inputData,
                        inputStateChangeFunction: setInputData,
                        errorData: errorData,
                        updateErrorData: setErrorData,
                        rowRightExtras: <React.Fragment>
                            <div className='gfbi-btns'>
                                <GenericCustomButton
                                    label="Clear All"
                                    type="default"
                                    onClick={() => setInputData({})}
                                    disabled={Object.keys(inputData || {}).length === 0}
                                />
                            </div>
                        </React.Fragment>,
                    }}
                    availableDocument={props.availableDocument || null}
                />
            </div>
        )
    }

    return (
        <div className='pl-[30px] pr-[15px] pb-[15px] pt-[16px] mt-[-16px] overflow-hidden'>
            {renderPrimaryFilters()}
            {/* <div className='my-4 px-3 py-3 bg-white' style={{ boxShadow: '0px 4px 20px -16px #8B93BB' }}>
                <div className='h-[38px] w-auto'>
                    <img className='h-full w-full object-contain object-left' src={tokenData?.org_logo || ProfilePlaceholder} loading="lazy" />
                </div>
            </div> */}
            <>
                {getPiSummaryData?.isLoading ? renderLoadingSkeleton() :
                    <div className='space-y-5 text-[#0F172A] mt-1'>
                        <div className='grid grid-cols-1 h-full gap-5'>
                            <div className='w-full grid grid-cols-2 gap-5'>
                                <div className='h-full flex flex-col gap-5 text-fontBlack'>
                                    <div className='px-4 pt-[12px] bg-gradient-to-b from-[#FF9C00]/35 to-transparent'>
                                        <div className="flex items-center justify-between gap-3">
                                            <div className="">
                                                <LanguageTranslator tag='p' className="text-[15px] font-semibold">Purchase Indents</LanguageTranslator>
                                                <div className="group relative">
                                                    <p className="text-[29px] font-semibold">{formatNumber(userDashboardData?.[`pi_qty`])?.short}<span className="text-[10px] font-normal"> Qty</span></p>
                                                    {formatNumber(userDashboardData?.[`pi_qty`])?.full && <span className="generic-tooltip group-hover:visible group-hover:opacity-100">{formatNumber(userDashboardData?.[`pi_qty`])?.full}</span>}
                                                </div>
                                            </div>
                                            {/* <div className="flex items-center gap-5"> */}
                                            <div>
                                                <LanguageTranslator tag='p' className="text-fontblack text-[11px] font-medium mb-1">Amount</LanguageTranslator>
                                                <div className="group relative">
                                                    <div className="text-[30px] font-medium flex items-center gap-1">
                                                        <span>
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-indian-rupee"><path d="M6 3h12"></path><path d="M6 8h12"></path><path d="m6 13 8.5 8"></path><path d="M6 13h3"></path><path d="M9 13c6.667 0 6.667-10 0-10"></path></svg>
                                                        </span>{formatNumber(userDashboardData?.[`pi_amount`])?.short}
                                                    </div>
                                                    {formatNumber(userDashboardData?.[`pi_amount`])?.full && <div className="generic-tooltip group-hover:visible group-hover:opacity-100">{formatNumber(userDashboardData?.[`pi_amount`])?.full}</div>}
                                                </div>
                                            </div>
                                            <div>
                                                <LanguageTranslator tag='p' className="text-fontBlack text-xs font-medium mb-1">Count</LanguageTranslator>
                                                <div className="group relative">
                                                    <div className="text-[30px] font-medium">{formatNumber(userDashboardData?.[`pi_count`])?.short}</div>
                                                    {formatNumber(userDashboardData?.[`pi_count`])?.full && <div className="generic-tooltip !left-0 group-hover:visible group-hover:opacity-100">{formatNumber(userDashboardData?.[`pi_count`])?.full}</div>}
                                                </div>
                                            </div>
                                            {/* </div> */}
                                        </div>
                                        <div className='mt-[24px] mb-8 flex items-start gap-2'>
                                            <div className='p-[4px] rounded bg-[#20BF6B]'><ScrollText size={11} color='white' /></div>
                                            <LanguageTranslator tag='p' className='mb-0 text-xs font-normal'>This section highlights key metrics like Purchase Indents quantities procured, and overall transaction count with amount.</LanguageTranslator>
                                        </div>
                                    </div>
                                </div>
                                <div className='h-full flex flex-col gap-5 text-fontBlack'>
                                    <div className='px-4 pt-[12px] bg-gradient-to-b from-[#ADAEFE]/35 to-transparent'>
                                        <div className="flex items-center justify-between gap-3">
                                            <div className="">
                                                <LanguageTranslator tag='p' className="text-[15px] font-semibold">Purchase Orders</LanguageTranslator>
                                                <div className="group relative">
                                                    <p className="text-[29px] font-semibold">{formatNumber(userDashboardData?.[`po_qty`])?.short}
                                                        <span className="text-[10px] font-normal"> Qty</span>
                                                    </p>
                                                    {formatNumber(userDashboardData?.[`po_qty`])?.full && <span className="generic-tooltip group-hover:visible group-hover:opacity-100">{formatNumber(userDashboardData?.[`po_qty`])?.full}</span>}
                                                </div>
                                            </div>
                                            {/* <div className="flex items-center gap-5"> */}
                                            <div>
                                                <LanguageTranslator tag='p' className="text-fontBlack text-xs font-medium mb-1">Amount</LanguageTranslator>
                                                <div className="group relative">
                                                    <div className="text-[30px] font-medium flex items-center gap-1">
                                                        <span>
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-indian-rupee"><path d="M6 3h12"></path><path d="M6 8h12"></path><path d="m6 13 8.5 8"></path><path d="M6 13h3"></path><path d="M9 13c6.667 0 6.667-10 0-10"></path></svg>
                                                        </span>{formatNumber(userDashboardData?.[`po_amount`])?.short}
                                                    </div>
                                                    {formatNumber(userDashboardData?.[`po_amount`])?.full && <div className="generic-tooltip group-hover:visible group-hover:opacity-100">{formatNumber(userDashboardData?.[`po_amount`])?.full}</div>}
                                                </div>
                                            </div>
                                            <div>
                                                <LanguageTranslator tag='p' className="text-fontBlack text-xs font-medium mb-1">Count</LanguageTranslator>
                                                <div className="group relative">
                                                    <div className="text-[30px] font-medium">{formatNumber(userDashboardData?.[`po_count`])?.short}</div>
                                                    {formatNumber(userDashboardData?.[`po_count`])?.full && <div className="generic-tooltip group-hover:visible group-hover:opacity-100">{formatNumber(userDashboardData?.[`po_count`])?.full}</div>}
                                                </div>
                                            </div>
                                            {/* </div> */}
                                        </div>
                                        <div className='mt-[24px] mb-8 flex items-start gap-2'>
                                            <div className='p-[4px] rounded bg-[#20BF6B]'><ScrollText size={11} color='white' /></div>
                                            <LanguageTranslator tag='p' className='mb-0 text-xs font-normal'>This section highlights key metrics like Purchase Orders quantities procured, and overall transaction count with amount.</LanguageTranslator>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                <div className='flex items-center justify-center mt-[3vh] 2xl:mt-[10vh] p-[1rem]'>
                    <div className='h-[25vh] 2xl:h-[30vh] w-full max-h-[250px] 2xl:max-h-[400px]'>
                        <Icons.SupplymintGrey className='h-full w-full opacity-10 object-contain' />
                    </div>
                </div>
            </>
        </div>
    )
}

export default UserDashboard